// Réessai des requêtes sur les erreurs PASSAGÈRES : quota momentanément atteint (429),
// proxy ou serveur en cours de redémarrage pendant un déploiement (502/503/504),
// délai dépassé (408) ou coupure réseau. Une requête refusée pour ces raisons n'a pas
// été traitée : la renvoyer est sans risque.

export const TRANSIENT_STATUSES = new Set([408, 429, 502, 503, 504]);

const defaultSleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Délai avant la prochaine tentative : celui demandé par le serveur (Retry-After, en
// secondes) quand il existe, sinon attente exponentielle 1 s, 2 s, 4 s… plafonnée.
export const retryDelayMs = (response, attempt, { baseMs = 1000, maxMs = 30000 } = {}) => {
  const header = response && response.headers && typeof response.headers.get === 'function'
    ? response.headers.get('Retry-After')
    : null;
  const seconds = header != null ? parseInt(header, 10) : NaN;
  if (Number.isFinite(seconds) && seconds >= 0) return Math.min(seconds * 1000, maxMs);
  return Math.min(baseMs * 2 ** attempt, maxMs);
};

// doFetch : fonction qui lance la requête (appelée à chaque tentative).
// Renvoie la dernière réponse obtenue ; ne lève que si le réseau échoue à chaque fois.
export async function fetchWithRetry(doFetch, {
  retries = 6, baseMs = 1000, maxMs = 30000, sleep = defaultSleep, onRetry
} = {}) {
  for (let attempt = 0; ; attempt++) {
    let response = null;
    let error = null;
    try {
      response = await doFetch();
    } catch (e) {
      error = e;
    }
    const transient = error !== null || TRANSIENT_STATUSES.has(response.status);
    if (!transient || attempt >= retries) {
      if (error) throw error;
      return response;
    }
    const wait = retryDelayMs(response, attempt, { baseMs, maxMs });
    if (onRetry) onRetry({ attempt: attempt + 1, wait, status: response ? response.status : null });
    await sleep(wait);
  }
}
